import {setResize} from './set-resize';
import {updateSvgScale} from './svg-scale';

export const resize = (): void => {
  let resizeTimeout: NodeJS.Timeout;
  const observer = new ResizeObserver(() => {
    // Update SVG scale immediately
    updateSvgScale();
    console.log('updateSvgScale');

    // Keep the delayed setResize for other functionality
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      setResize();
    }, 2000);
  });

  observer.observe(document.body);
  window.addEventListener('orientationchange', () => {
    updateSvgScale();
    setResize();
  });
};
